module.exports = __webpack_public_path__ + "img/shoppinglist.c3b35463.svg";